<template>
  <el-table-column
    prop="rate_date"
    sortable="custom"
    label="Leltárak kiértékelése"
    show-overflow-tooltip
    min-width="190"
  >
    <template slot-scope="scope">
      {{ scope.row.rate_date | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'rate_date',
  };
</script>
